/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/RcVideo';
export default {
  scheduleFor: '代表以下對象進行排程',
  scheduleForAssistedUser: '代表 {userName} 更新會議設定。',
  scheduleForGuidance:
    '要為其他人排程嗎？\n1. 請確認您在他們的 Outlook 行事曆中。\n2. 從下拉選單中選取您要幫助其排程的人員。\n',
  scheduleForGuidanceMore: '瞭解詳細資訊',
  meetingSettings: '會議設定',
  meetingSettingsDescription: '更新將僅套用至此會議。',
  [ASSISTED_USERS_MYSELF]: '我本人',
  waitingRoomTitle: '使用等候室',
  waitingRoomDescription:
    '參與者需要一直等待，等到您准許他們加入。非常適合面試或邀請外部與會者參加。',
  waitingRoomNotCoworker: '適用於公司以外的任何人',
  waitingRoomGuest: '適用於任何未登入的人',
  waitingRoomAll: '適用於所有參與者',
  enterPassword: '輸入密碼',
  onlyJoinAfterMe: '在您加入後開始會議',
  allowJoinBeforeHostDescription:
    '為了防止對話提前進行，會議將在您加入後開始。',
  requirePassword: '需要密碼',
  requirePasswordDescription:
    '確保會議安全。系統不會提示使用該連結的任何人輸入密碼。',
  password: '密碼：',
  passwordEmptyError: '需要會議密碼',
  passwordInvalidError: '您的密碼須為 1 到 10 個字母和數字，但不得包含任何符號',
  passwordHintText: '您的密碼應為 1 到 10 個字母和數字，但不得包含任何符號。',
  usePersonalMeetingIdInstead: '使用個人會議連結',
  allowMeetingAccess: '管理哪些人可加入',
  anyoneWithLink: '收到連結的任何人',
  signedInUsers: '僅限 {shortName} 帳戶',
  signedInCoWorkers: '僅限我的同事',
  passwordLabel: '密碼',
  edit: '編輯',
  editSettings: '編輯設定',
  lockTooltip: '此設定由公司管理員管理',
  cancel: '取消',
  update: '更新',
  pmiSettingsTitle: '個人會議設定',
  pmiSettingsDescription:
    '設定哪些人可以使用您的個人會議連結加入，以及如何加入。',
} as const;

// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"scheduleForAssistedUser"@#@ @source: @#@"Update meetings settings on behalf of {userName}."@#@
// @key: @#@"scheduleForGuidance"@#@ @source: @#@"Scheduling for someone else?\n1. Make sure you're on their Outlook calendar.\n2. From the dropdown, select the person you're scheduling for.\n"@#@
// @key: @#@"scheduleForGuidanceMore"@#@ @source: @#@"Learn details"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"meetingSettingsDescription"@#@ @source: @#@"Updates will apply to this meeting only."@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"waitingRoomTitle"@#@ @source: @#@"Use waiting room"@#@
// @key: @#@"waitingRoomDescription"@#@ @source: @#@"Participants wait until you admit them. Great for interviews or outside attendees."@#@
// @key: @#@"waitingRoomNotCoworker"@#@ @source: @#@"For anyone outside my company"@#@
// @key: @#@"waitingRoomGuest"@#@ @source: @#@"For anyone not signed in"@#@
// @key: @#@"waitingRoomAll"@#@ @source: @#@"For all participants"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"onlyJoinAfterMe"@#@ @source: @#@"Start meeting after you join"@#@
// @key: @#@"allowJoinBeforeHostDescription"@#@ @source: @#@"The meeting will start after you join to prevent early conversations."@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"requirePasswordDescription"@#@ @source: @#@"Keep your meeting secure. Anyone using the link won't be prompted for a password."@#@
// @key: @#@"password"@#@ @source: @#@"Password:"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"passwordInvalidError"@#@ @source: @#@"Your password must be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"passwordHintText"@#@ @source: @#@"Your password should be 1-10 letters and numbers long, but can not contain symbols."@#@
// @key: @#@"usePersonalMeetingIdInstead"@#@ @source: @#@"Use personal meeting link"@#@
// @key: @#@"allowMeetingAccess"@#@ @source: @#@"Manage who can join"@#@
// @key: @#@"anyoneWithLink"@#@ @source: @#@"Anyone with link"@#@
// @key: @#@"signedInUsers"@#@ @source: @#@"Only {shortName} accounts"@#@
// @key: @#@"signedInCoWorkers"@#@ @source: @#@"Only my coworkers"@#@
// @key: @#@"passwordLabel"@#@ @source: @#@"Password"@#@
// @key: @#@"edit"@#@ @source: @#@"Edit"@#@
// @key: @#@"editSettings"@#@ @source: @#@"Edit settings"@#@
// @key: @#@"lockTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"update"@#@ @source: @#@"Update"@#@
// @key: @#@"pmiSettingsTitle"@#@ @source: @#@"Personal meeting settings"@#@
// @key: @#@"pmiSettingsDescription"@#@ @source: @#@"Set who can join and how for your personal meeting link."@#@
